// ===== 51吃料 · 首页静态内容数据 =====

// ---- 首屏「今日主推」多卡 ----
export const HERO_CARDS = [
  {
    id: 'hero-1',
    tag: '今日头牌',
    title: '下班后的第一顿「电子宵夜」指南',
    desc: '把当周最顺口的内容拢成一份热乎的下饭清单，先看哪篇、再看哪篇都替你排好。',
    meta: '今日 21:00 已更',
    comments: 326,
    hot: true,
    src: 'https://readdy.ai/api/search-image?query=A%20minimalist%20editorial%20illustration%20of%20a%20steaming%20food%20bowl%20glowing%20under%20radiant%20warm%20sunburst%20rays%20in%20soft%20coral%20and%20cream%20tones%20clean%20flat%20shapes%20on%20a%20warm%20matte%20paper%20background%20with%20generous%20empty%20space%20premium%20food%20culture%20feature%20art%20no%20text&width=800&height=600&seq=chiliao-hero1&orientation=landscape',
  },
  {
    id: 'hero-2',
    tag: '升温最快',
    title: '评论区比正片还精彩的一周神回复',
    desc: '弹幕、神回复、高能热评集中上榜，笑点密集到需要备纸巾。',
    meta: '互动量 本周前三',
    comments: 209,
    hot: false,
    src: 'https://readdy.ai/api/search-image?query=A%20minimalist%20flat%20editorial%20graphic%20of%20stacked%20newspaper%20lines%20with%20a%20playful%20upward%20arrow%20and%20spark%20marks%20in%20warm%20terracotta%20and%20cream%20palette%20on%20a%20soft%20paper%20background%20with%20clean%20negative%20space%20trending%20summary%20art%20no%20text&width=800&height=600&seq=chiliao-hero2&orientation=landscape',
  },
  {
    id: 'hero-3',
    tag: '编辑力荐',
    title: '一张清单收下最近大家在囤的「宝藏好物」',
    desc: '从隐藏菜单到小众玩法，按人气排序打包成组，闭眼跟买不踩雷。',
    meta: '完整列表见下',
    comments: 158,
    hot: false,
    src: 'https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20still%20life%20of%20freshly%20prepared%20hotpot%20ingredients%20arranged%20in%20neat%20rows%20with%20warm%20orange%20and%20cream%20tones%20on%20a%20clean%20light%20background%20appetizing%20cozy%20flat%20lay%20style%20no%20text&width=800&height=600&seq=chiliao-hero3&orientation=landscape',
  },
];

// ---- 今日汇总 · 快讯时间线 ----
export const FEED_ITEMS = [
  {
    id: 'feed-1',
    time: '08:24',
    stage: '早间',
    title: '「早间版」新鲜出炉的一批热榜速览已经归位，晨起第一口料先垫垫肚子。',
    source: '今日汇总',
    comments: 47,
    live: false,
  },
  {
    id: 'feed-2',
    time: '09:47',
    stage: '上午',
    title: '大家都在看的当红合集补了新一轮更新，老料打包、新料续杯。',
    source: '热门合集',
    comments: 92,
    live: false,
  },
  {
    id: 'feed-3',
    time: '11:05',
    stage: '午间',
    title: '网友呼声最高的一组神评论新鲜上榜，评论区已提前开火。',
    source: '热评现场',
    comments: 176,
    live: false,
  },
  {
    id: 'feed-4',
    time: '14:32',
    stage: '午后',
    title: '精选打包页换了新封面，本周合集合拢扩容，一键就能取整份。',
    source: '精选打包',
    comments: 63,
    live: false,
  },
  {
    id: 'feed-5',
    time: '18:19',
    stage: '傍晚',
    title: '加班党友好：晚间慢速下饭合集开放，完整体验跟着节奏慢慢来。',
    source: '完整列表',
    comments: 118,
    live: false,
  },
  {
    id: 'feed-6',
    time: '21:00',
    stage: '收官',
    title: '本日汇总榜单更新完毕，全站列表刷新，评论区正式开张，欢迎补料。',
    source: '今日收官',
    comments: 251,
    live: true,
  },
];

// ---- 热门合集 · 封面策展墙 ----
export const HOT_COLLECTIONS = [
  {
    id: 'col-1',
    name: '深夜剧场',
    desc: '越夜越香的下饭专场',
    comments: 1864,
    src: 'https://readdy.ai/api/search-image?query=A%20cozy%20editorial%20illustration%20of%20a%20quiet%20late%20night%20room%20with%20a%20glowing%20tv%20screen%20and%20snacks%20on%20a%20tray%20in%20warm%20dim%20amber%20tones%20portrait%20magazine%20cover%20art%20moody%20clean%20matte%20background%20no%20text&width=600&height=800&seq=chiliao-col-a&orientation=portrait',
  },
  {
    id: 'col-2',
    name: '高能弹幕',
    desc: '一开口就是全场最佳',
    comments: 1527,
    src: 'https://readdy.ai/api/search-image?query=A%20playful%20flat%20editorial%20illustration%20of%20floating%20speech%20bubbles%20and%20comment%20icons%20scattered%20on%20a%20cream%20and%20terracotta%20background%20with%20soft%20shadows%20portrait%20magazine%20cover%20art%20energetic%20but%20minimal%20no%20text&width=600&height=800&seq=chiliao-col-b&orientation=portrait',
  },
  {
    id: 'col-3',
    name: '隐藏菜单',
    desc: '只有老饕才知道的去处',
    comments: 1180,
    src: 'https://readdy.ai/api/search-image?query=A%20minimalist%20editorial%20illustration%20of%20a%20charming%20small%20shopfront%20with%20a%20striped%20awning%20and%20hanging%20sign%20bathed%20in%20warm%20daylight%20portrait%20magazine%20cover%20art%20clean%20cream%20background%20no%20text&width=600&height=800&seq=chiliao-col-c&orientation=portrait',
  },
  {
    id: 'col-4',
    name: '当红好物',
    desc: '本周大家在囤的清单',
    comments: 943,
    src: 'https://readdy.ai/api/search-image?query=A%20neat%20editorial%20flat%20lay%20of%20curated%20trendy%20objects%20arranged%20in%20rows%20on%20warm%20paper%20with%20soft%20natural%20shadow%20portrait%20magazine%20cover%20art%20minimal%20terracotta%20and%20cream%20palette%20no%20text&width=600&height=800&seq=chiliao-col-d&orientation=portrait',
  },
  {
    id: 'col-5',
    name: '一人食',
    desc: '自己吃也要好好吃',
    comments: 786,
    src: 'https://readdy.ai/api/search-image?query=A%20warm%20editorial%20illustration%20of%20a%20single%20place%20setting%20with%20one%20steaming%20dish%20and%20chopsticks%20on%20a%20small%20wooden%20table%20portrait%20magazine%20cover%20art%20cozy%20minimal%20cream%20background%20no%20text&width=600&height=800&seq=chiliao-col-e&orientation=portrait',
  },
  {
    id: 'col-6',
    name: '冷知识库',
    desc: '吃完还能带走点知识',
    comments: 652,
    src: 'https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20illustration%20of%20an%20open%20book%20with%20small%20glowing%20fact%20sparks%20and%20lightbulbs%20floating%20above%20portrait%20magazine%20cover%20art%20warm%20neutral%20background%20curious%20clean%20no%20text&width=600&height=800&seq=chiliao-col-f&orientation=portrait',
  },
];

// ---- 精选打包 · 一键取整份 ----
export const PACKS = [
  {
    id: 'pack-1',
    name: '本周精选合集',
    count: '28 篇 · 一键打包',
    tagline: '编辑部攒了一周的口味，一次全拿走。',
    tags: ['今日汇总', '热门合集', '完整列表'],
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20flat%20editorial%20banner%20of%20a%20grid%20of%20mini%20content%20cards%20neatly%20packed%20with%20a%20rounded%20arrow%20download%20seal%20in%20the%20center%20warm%20terracotta%20and%20cream%20palette%20generous%20negative%20space%20no%20text&width=800&height=450&seq=chiliao-pack-a&orientation=landscape',
  },
  {
    id: 'pack-2',
    name: '当红好物全家桶',
    count: '12 组 · 分类收拢',
    tagline: '按人气归好档的宝藏集合，整盒带走不迷路。',
    tags: ['精选打包', '一键看', '人气榜'],
    src: 'https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20banner%20of%20an%20open%20collection%20box%20with%20colorful%20tabbed%20dividers%20stacked%20inside%20on%20a%20soft%20cream%20background%20warm%20tones%20clean%20flat%20illustration%20no%20text&width=800&height=450&seq=chiliao-pack-b&orientation=landscape',
  },
  {
    id: 'pack-3',
    name: '一周回看清单',
    count: '7 天 · 每日一份',
    tagline: '没赶上直播也不怕，漏掉的料都在这里补齐。',
    tags: ['每日汇总', '合集归档', '不重样'],
    src: 'https://readdy.ai/api/search-image?query=A%20minimalist%20editorial%20banner%20showing%20a%20checklist%20board%20with%20tick%20marks%20and%20small%20folder%20icons%20on%20a%20warm%20paper%20background%20terracotta%20and%20olive%20accents%20clean%20flat%20no%20text&width=800&height=450&seq=chiliao-pack-c&orientation=landscape',
  },
];

// ---- 热评现场 ----
export const HOT_COMMENTS = [
  {
    id: 'c-1',
    user: '熬夜冠军小张',
    likes: 1284,
    text: '我宣布今晚这口「料」封神了，弹幕区已经在开香槟，我先干为敬。',
    tag: '深夜剧场',
  },
  {
    id: 'c-2',
    user: '吃饭不能没有下饭菜',
    likes: 867,
    text: '打包的那个合集太顶了，一次看完全身通畅，第二天还能跟同事聊起来。',
    tag: '精选打包',
  },
  {
    id: 'c-3',
    user: '路过吃瓜的羊',
    likes: 542,
    text: '评论区永远比本体精彩这句话，我在 51吃料已经验证了第三回。',
    tag: '高能弹幕',
  },
  {
    id: 'c-4',
    user: '老板在隔壁码代码',
    likes: 315,
    text: '建议加一个「追更提醒」，不然我每天 21:00 都蹲点刷新。',
    tag: '功能许愿',
  },
];